/**
 * Dedication (custom_text) pricing tiers:
 * - Empty / no text → ₪0
 * - 1-10 words     → ₪30
 * - 11+ words      → ₪60
 */
export const DEDICATION_TIER_SHORT = 30;
export const DEDICATION_TIER_LONG = 60;
export const DEDICATION_WORD_THRESHOLD = 10;

export const countWords = (text?: string | null): number => {
  if (!text) return 0;
  const trimmed = text.trim();
  if (!trimmed) return 0;
  return trimmed.split(/\s+/).filter(Boolean).length;
};

export const getDedicationFee = (text?: string | null): number => {
  const words = countWords(text);
  if (words === 0) return 0;
  if (words <= DEDICATION_WORD_THRESHOLD) return DEDICATION_TIER_SHORT;
  return DEDICATION_TIER_LONG;
};

export const getDedicationLabel = (text?: string | null): string => {
  const fee = getDedicationFee(text);
  if (fee === 0) return "";
  const words = countWords(text);
  return `הקדשה (${words} מילים) - ₪${fee}`;
};

/** Personal design (mockup / uploaded artwork) surcharge */
export const CUSTOM_DESIGN_FEE = 30;

/** Total per-unit surcharge for a cart item (dedication + personal design) */
export const getItemExtrasFee = (item: { customText?: string | null; customDesign?: boolean }): number =>
  getDedicationFee(item.customText) + (item.customDesign ? CUSTOM_DESIGN_FEE : 0);
